/**
 * The card draw duration.
 * @type {number}
 * @constant
 */
const CARD_DRAW = 400;

/**
 * The card play duration.
 * @type {number}
 * @constant
 */
const CARD_PLAY = 100;

export {

    CARD_DRAW,
    CARD_PLAY
};
